export default function () {
  return {
    numberOfLinks: 0,
    totalSpace: 0,
    breakWidths: [],
    availableSpace: 0,
    numberOfVisibleLinks: 0,
    requiredSpace: 0,
    navLinks: null,
    hiddenNavLinks: null,
    menuIsOpen: false,
    checkbox: false,
    windowWidth: window.innerWidth,
    linksWidth: [],

    init() {
      this.navLinks = this.$refs.navLinks;
      this.hiddenNavLinks = this.$refs.hiddenNavLinks;

      const getLinksWidth = () => {
        for (const child of Array.from(this.navLinks.children)) {
          this.linksWidth.push(child.offsetWidth);
          this.totalSpace += child.offsetWidth;
          this.numberOfLinks += 1;
          this.breakWidths.push(this.totalSpace);
        }
      };

      getLinksWidth();
      this.updateNav();

      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.windowWidth = entry.contentRect.width;
          this.updateNav();
        }
      });

      resizeObserver.observe(document.documentElement);
    },
    updateNav() {
      this.availableSpace = this.navLinks.offsetWidth - 42;
      this.numberOfVisibleLinks = this.navLinks.children.length;
      this.requiredSpace = this.breakWidths[this.numberOfVisibleLinks - 1];
      if (this.requiredSpace > this.availableSpace) {
        this.navLinks.lastElementChild.classList.add('is-collapsed');

        this.hiddenNavLinks.insertBefore(
          this.navLinks.lastElementChild,
          this.hiddenNavLinks.firstChild,
        );
        this.numberOfVisibleLinks -= 1;
        this.updateNav();
      }
      if (
        this.breakWidths[this.numberOfVisibleLinks] !== undefined &&
        this.availableSpace > this.breakWidths[this.numberOfVisibleLinks]
      ) {
        this.navLinks.appendChild(this.hiddenNavLinks.firstChild);
        this.navLinks.lastElementChild.classList.remove('is-collapsed');
        this.numberOfVisibleLinks += 1;
      }
    },
  };
}
